import React from 'react';
import {
  Box,
  Controller,
  ControllerWrapper,
  FieldWrapper,
  FormFieldsContainer,
  RegularField,
  useFormContext
} from '@common-fe/common-fe';

import { ResetPasswordField, ResetPasswordForm } from '@/modules/user/components/ResetPassword/hooks/useResetPasswordForm';

interface Props {
  editMode?: boolean;
}

const ResetPasswordFields: React.FC<Props> = () => {
  const { control, formState: { errors } } = useFormContext<ResetPasswordForm>();

  return (
    <Box data-testid="reset-password_fields">
      <FormFieldsContainer>
        <FieldWrapper>
          <ControllerWrapper errorText={errors?.[ResetPasswordField.newPassword]?.message}>
            <Controller
              name={ResetPasswordField.newPassword}
              control={control}
              render={({ field }) => (
                <RegularField
                  testId="reset-password_new-password"
                  name={ResetPasswordField.newPassword}
                  value={field.value}
                  onChange={field.onChange}
                  editMode
                  placeholder="Enter new password"
                  isError={!!errors?.[ResetPasswordField.newPassword]?.message}
                  passwordHelper
                  isLarge
                  passwordHelperLeftPosition
                  type="password"
                />
              )}
            />
          </ControllerWrapper>
        </FieldWrapper>

        <FieldWrapper>
          <ControllerWrapper errorText={errors?.[ResetPasswordField.confirmNewPassword]?.message}>
            <Controller
              name={ResetPasswordField.confirmNewPassword}
              control={control}
              render={({ field }) => (
                <RegularField
                  testId="reset-password_confirm-password"
                  name={ResetPasswordField.confirmNewPassword}
                  value={field.value}
                  onChange={field.onChange}
                  editMode
                  isLarge
                  placeholder="Confirm new password"
                  isError={!!errors?.[ResetPasswordField.confirmNewPassword]?.message}
                  type="password"
                />
              )}
            />
          </ControllerWrapper>
        </FieldWrapper>
      </FormFieldsContainer>
    </Box>
  );
};

export default ResetPasswordFields;
